import { useEffect } from 'react';
import { makeStyles } from '@material-ui/core';


function LitScoreCommentary(props: any) {
    const classes = useStyles();
    const { litObject, confidenceScore } = props;

    useEffect(() => {

    }, []);



    const getCommentary = () => {
        let r = '';

        if (litObject?.score >= 66) {
            if (litObject.color === 'green') {
                //high score/high safety
                if (litObject?.shape === 'flat') {
                    r = `The high Immersion and Psychological Safety during this session puts your audience in a great place, even when the overall shape of the session was flat. A flat shape with high Immersion is a good place to be, it means your audience is likely to remember and act on this experience.`;
                } else if (litObject?.shape === 'up') {
                    r = `Great work! The session started down but ended very strong.  With high Immersion and high Safety, you should feel confident that people will take action and will likely say very good things about this experience.`;
                } else if (litObject?.shape === 'down') {
                    r = `These are great scores, but the session ended on a down note.  Overall Immersion and Safety were very strong, so nothing to stress about.`;
                } else if (litObject?.shape === 'valley') {
                    r = `Nice! The overall scores for Immersion and Safety were super high, and this 'valley' shape shows that you started strong and ended strong.`;
                } else if (litObject?.shape === 'mtn') {
                    r = 'Your audience was really immersed in this session, with their highest levels happening in the middle.  With scores this high, that middle section must have been extraordinary.'
                }

            } else if (litObject.color === 'yellow') {
                //high score/med safety
                if (litObject?.shape === 'flat') {
                    r = `The high Immersion during this session puts your audience in a great place, even when the overall shape of the session was flat. One thing to check is the medium level of Psych Safety.  While a flat shape with high Immersion is a good place to be, the middle of the road Safety scores indicate the audience may lack the emotional 'bandwidth' for this content.`;
                } else if (litObject?.shape === 'up') {
                    r = `Great work! The session started down but ended very strong.  With high Immersion, you should feel confident that people will take action and will likely say very good things about this experience. Why do you think Safety was just middle of the road?`;
                } else if (litObject?.shape === 'down') {
                    r = `These are great scores, but the session ended on a down note, and the mid-level Safety score should give you something to focus on.  Overall Immersion was very strong.`;
                } else if (litObject?.shape === 'valley') {
                    r = `Nice! The overall scores for Immersion were super high, and this 'valley' shape shows that you started strong and ended strong.`;
                } else if (litObject?.shape === 'mtn') {
                    r = 'Your audience was really immersed in this session, with their highest levels happening in the middle.  With scores this high, that middle section must have been extraordinary. However, you may want to think about why the Safety scores were down the middle.'
                }
            } else {
                //high score/low safety
                if (litObject?.shape === 'flat') {
                    r = `The high Immersion during this session puts your audience in a great place, even when the overall shape of the session was flat. One thing to check is the low level of Psych Safety.  While a flat shape with high Immersion is a good place to be, the low Safety scores indicate the audience may lack the emotional 'bandwidth' for this content. `;
                } else if (litObject?.shape === 'up') {
                    r = `Great work! The session started down but ended very strong.  With high Immersion, you should feel confident that people will take action and will likely say very good things about this experience. Why do you think Safety was this low?`;
                } else if (litObject?.shape === 'down') {
                    r = `These are great scores, but the session ended on a down note, and the low-level Safety score should give you something to focus on.  Overall Immersion was very strong.`;
                } else if (litObject?.shape === 'valley') {
                    r = `Nice! The overall scores for Immersion were super high, and this 'valley' shape shows that you started strong and ended strong. Was the content troubling for the audience? The low Safety in the room is something to probe.`;
                } else if (litObject?.shape === 'mtn') {
                    r = 'Your audience was really immersed in this session, with their highest levels happening in the middle.  With scores this high, that middle section must have been great. However, you may want to think about why the Safety scores were this low.'
                }
 
            }
        } else if (litObject?.score >= 36 && litObject?.score < 66) {
            if (litObject.color === 'green') {
                //med score/high safety
                if (litObject?.shape === 'flat') {
                    r = `The mid-level Immersion and high Psychological Safety during this session puts your audience in a pretty good place, even when the overall shape of the session was flat. There are likely some major high points during this session, and the audience was well prepared to engage. `;
                } else if (litObject?.shape === 'up') {
                    r = `Great work! The session started down, but ended very strong.  With medium Immersion and high Safety you should feel confident that people will be more likely to take action and will probably say very good things about this experience.`;
                } else if (litObject?.shape === 'down') {
                    r = `These are pretty good scores, but the session ended on a down note.  Overall Immersion was about average for this type of experience and Safety was very strong, so nothing to stress about.`;
                } else if (litObject?.shape === 'valley') {
                    r = `The overall scores for Immersion were 'middle-of-the-road' and Safety was super high. This 'valley' shape shows that you started strong and ended strong.`;
                } else if (litObject?.shape === 'mtn') {
                    r = 'Your audience was mostly immersed in this session, with their highest levels happening in the middle.  With overall Immersion scores in the mid-range you may want to look at how you can start/end better.'
                }

            } else if (litObject.color === 'yellow') {
                //med score/med safety
                if (litObject?.shape === 'flat') {
                    r = `This was a pretty average session all around.  The flat shape along with the mid-level Immersion and Safety scores show that this was an ok experience for the audience, but nothing to write home about.`;
                } else if (litObject?.shape === 'up') {
                    r = `The good news is that you ended strong. So even with Immersion and Safety scores in this average range, your best bits are going to be remembered in the end.`;
                } else if (litObject?.shape === 'down') {
                    r = `You started strong here but could not maintain the flow.  With average Immersion and Safety scores, you probably started very strong but just didn't sustain for the entire time. `;
                } else if (litObject?.shape === 'valley') {
                    r = `A good meeting starts and ends strong, which this one does.  However, the mid-level Immersion and Safety results should tell you that there is room to improve.`;
                } else if (litObject?.shape === 'mtn') {
                    r = 'The middle bit was strong, but to have mid-level Immersion and Safety scores, the beginning and end must have been pretty grim.'
                }
 
 
            } else {
                //med score/low safety
                if (litObject?.shape === 'flat') {
                    r = `This was a pretty average session all around.  The flat shape, along with the mid-level Immersion and low Safety scores, shows that this was an ok experience for the audience, but you should be concerned about the audience's Safety.`;
                } else if (litObject?.shape === 'up') {
                    r = `The good news is that you ended strong. So even with Immersion in this average range, your best bits are going to be remembered in the end. The low Safety is a signal that the room was not ready to engage.`;
                } else if (litObject?.shape === 'down') {
                    r = `You started strong here but could not maintain the flow.  With average Immersion and low Safety scores, you probably started very strong but just didn't sustain for the entire time. `;
                } else if (litObject?.shape === 'valley') {
                    r = `A good meeting starts and ends strong, which this one does.  However, the mid-level Immersion and low Safety results should tell you that there is room to improve.`;
                } else if (litObject?.shape === 'mtn') {
                    r = 'The middle bit was strong, but to have mid-level Immersion and low Safety scores, the beginning and end must have been pretty grim. A low Safety score indicates the audience was not ready to participate.'
                }
 
            }
        } else {
            ////here
            if (litObject.color === 'green') {
                //low score/high safety
                if (litObject?.shape === 'flat') {
                    r = `Hmmm... The low Immersion and high Psychological Safety during this session puts your audience in a pretty good place, but their brains just didn't find any value in the experience.`;
                } else if (litObject?.shape === 'up') {
                    r = `You were trending up, but with such low Immersion and high Safety, you should be concerned that people will not take action and will probably not say very good things about this experience.`;
                } else if (litObject?.shape === 'down') {
                    r = `These are pretty rough Immersion scores, and the session ended on a down note.  Overall Immersion was low for this type of experience -- but Safety was very strong, so the audience wanted to learn, but their brains tuned out.`;
                } else if (litObject?.shape === 'valley') {
                    r = `The overall scores for Immersion were not great -- but Safety was super high. This 'valley' shape shows that you started strong and ended strong. However, with such low Immersion, you should be concerned.`;
                } else if (litObject?.shape === 'mtn') {
                    r = 'You captured some Immersion in the middle of this session, but even that was too little to make a significant difference. Your audience was feeling psychologically safe, but their brains just did not value the experience.'
                }
 
            } else if (litObject.color === 'yellow') {
                //low score/med safety
                if (litObject?.shape === 'flat') {
                    r = `Hmmm... The low Immersion and medium Psychological Safety during this session puts your audience in a reasonable place, but their brains just didn't find any value in the experience.`;
                } else if (litObject?.shape === 'up') {
                    r = `You were trending up, but with such low Immersion and medium Safety, you should be concerned that people will not take action and will probably not say very good things about this experience.`;
                } else if (litObject?.shape === 'down') {
                    r = `These are pretty rough Immersion scores, and the session ended on a down note.  Overall Immersion was low for this type of experience, and Safety was only average, so the audience was moderately leaning in, but their brains tuned out.`;
                } else if (litObject?.shape === 'valley') {
                    r = `The overall scores for Immersion were not great -- and Safety was only average. This 'valley' shape shows that you started strong and ended strong. However, with such low Immersion, you should be concerned.`;
                } else if (litObject?.shape === 'mtn') {
                    r = 'You captured some Immersion in the middle of this session, but even that was too little to make a significant difference. Your audience was mostly feeling psychologically safe, but their brains just did not value the experience.'
                }
 
            } else {
                //low score/low safety
                if (litObject?.shape === 'flat') {
                    r = `Yikes. The low Immersion and low Psychological Safety during this session puts your audience in a place where their brains just didn't find any value in the experience.`;
                } else if (litObject?.shape === 'up') {
                    r = `You were trending up, but with such low Immersion and low Safety, you should be concerned that people will not take action and will probably not say very good things about this experience.`;
                } else if (litObject?.shape === 'down') {
                    r = `These are pretty rough Immersion scores, and the session ended on a down note.  Overall Immersion was low for this type of experience, and Safety was low, so the audience's brains were tuned out.`;
                } else if (litObject?.shape === 'valley') {
                    r = `The overall scores for Immersion were pretty rough -- and Safety was below average. This 'valley' shape shows that you started strong and ended strong. However, with such low Immersion and Safety, you should be concerned.`;
                } else if (litObject?.shape === 'mtn') {
                    r = 'You captured some Immersion in the middle of this session, but even that was too little to make a significant difference. Your audience was not feeling psychologically safe, and their brains just did not value the experience.'
                }
 
            }
        }

        return r;
    };

    const getRecommendation = () => {
        let r = '';

        if (litObject?.score >= 75) {
            //if (litObject.color === 'green') {
                //high score/high safety
                if (litObject?.shape === 'flat') {
                    r = `Keep doing what you are doing. This was a strong session.  You could look at the beginning and end to see if there are ways to better engage the audience in these sections.`;
                } else if (litObject?.shape === 'up') {
                    r = `You might want to have a look at the beginning of this experience.  What could you do to capture the audience right out of the gate? Have you tried starting with a story?`;
                } else if (litObject?.shape === 'down') {
                    r = `You need to focus some attention on the end of this experience. People tend to remember the peak moment and the end.  So, get some strong content at the end of this session.`;
                } else if (litObject?.shape === 'valley') {
                    r = `This a good shape for an experience like this, so keep doing what you are doing. You may want to look at the content in the middle and see if you can add a few more moments that will capture Immersion.`;
                } else if (litObject?.shape === 'mtn') {
                    r = 'Typically, we would want to see this shape flipped. Focus some attention on the beginning and end of the session.'
                }
 

            //}
        } else if (litObject?.score >= 40 && litObject?.score < 75) {
            //if (litObject.color === 'green') {
                //med score/high safety
                if (litObject?.shape === 'flat') {
                    r = `Keep doing what you are doing. This was a good session, but if you really want to drive new behavior, you will want to focus on increasing Immersion across the board. You could look at the beginning and end to see if there are ways to better engage the audience in these sections.`;
                } else if (litObject?.shape === 'up') {
                    r = `You might want to have a look at the beginning of this experience.  Focus on increasing emotional resonance with the audience.  What could you do to capture the audience right out of the gate?`;
                } else if (litObject?.shape === 'down') {
                    r = `You need to focus some attention on the end of this experience and the overall Immersion score. Get some strong content at the end of this session that will resonate with the audience.`;
                } else if (litObject?.shape === 'valley') {
                    r = `This a good shape for an experience like this, so keep doing what you are doing. The place to focus is on overall Immersion levels.  Look for ways to emotionally capture the audience with a story.`;
                } else if (litObject?.shape === 'mtn') {
                    r = 'Your highest Immersion was in the middle, but you probably want to see these high points at the beginning and end.  Maybe restructure the event agenda to get these high points in the right place.'
                }
 

            //}
        } else {
            ////here
            //if (litObject.color === 'green') {
                //low score/high safety




                if (litObject?.shape === 'flat') {
                    r = `You've got some work to do. The audience did not buy into this experience at all, so you need to focus on raising the emotional resonance of the content.  Why should someone care about this content?`;
                } else if (litObject?.shape === 'up') {
                    r = `You were trending up, but that's not saying a lot. Your audience warmed up to the experience over time, but you will need to find a way to start faster, so the audience cares about the experience from the beginning.`;
                } else if (litObject?.shape === 'down') {
                    r = `When you lose the audience like this, you have a content and structure problem.  Look at how you can reorganize the agenda for this experience and try to tune into why your audience should care about the topic.`;
                } else if (litObject?.shape === 'valley') {
                    r = `Your content agenda is probably pretty good, but no one seemed to care about the content. Try adding some personal stories or relating this content to a deeper 'why' that your audience can relate with.`;
                } else if (litObject?.shape === 'mtn') {
                    r = 'Flip this agenda around a bit. Move the bits from the middle to the beginning and/or end.  Once you have done that, you need to make a deeper emotional connection with the audience.'
                }
 
            //}
        }

        return r;
    };





    const getConfidenceCommentary = () => {
        let r = '';
        if (!!confidenceScore) {
            if (confidenceScore.includes('A')) {
                r = `Looking at the number of people that attended the event and the quality of data you captured, you should feel very confident in these recommendations.`;
            } else if (confidenceScore.includes('B')) {
                r = `Looking at the number of people that attended the event and the quality of data you captured, you might want to add a few people next time to raise your confidence in this result.`;
            } else if (confidenceScore.includes('C')) {
                r = `It's pretty interesting, right? Based on the number of people that attended the event and the quality of data you captured, you will need to add a few people next time before you make a big decision based on this data.`;
            } else {
                r = `Nice work.  Now, let's add a few people to really see the power of Immersion for live experiences.`;
            }
 
        }
        return r;
    };


    return (
        <>
            {litObject &&
                <ul id={'litcommentary'} className={classes.foo} style={{ lineHeight: '1.5' }}>
                    <li className={classes.liPadding} >{getCommentary()}</li>
                    <li className={classes.liPadding}>{getRecommendation()}</li>
                    <li className={classes.liPadding}>{getConfidenceCommentary()}</li>
                </ul>
            }
        </>
    );
}

export default LitScoreCommentary;

const useStyles = makeStyles(() => ({
    container: {
        flex: 1,
        display: 'flex',
        //marginLeft: -310,
        //marginTop: -100,
    },
    foo: {},
    liPadding: {
        paddingBottom: '15px',
        color: '#19191e',
        fontFamily: 'roboto-light',
    },
    bodyText: {
        color: '#697683',
        fontFamily: 'roboto-light',
    },
    litscoreTitle: {
        fontSize: 36,
        fontFamily: 'Spartan-bold',
        color: '#00000099',
        textAlign: 'left',
    },
    immbox: {
        width: '100px',
        background: '#00000099',
        padding: '5px',
        position: 'absolute',
        display: 'block',
        top: '-5px',
        textAlign: 'center',
        borderBottomRightRadius: '25%',
    },
    conbox: {
        width: '100px',
        background: '#00000099',
        padding: '5px',
        position: 'absolute',
        display: 'block',
        top: '-5px',
        right: '0px',
        textAlign: 'center',
        borderBottomLeftRadius: '25%',
    },
    boxScoreValue: {
        margin: '0px',
        paddingTop: '10px',
        fontSize: '50px',
        color: '#fff',
        fontFamily: 'Spartan-extrabold',
    },
    boxScoreLabel: {
        margin: '0px',
        fontSize: '10px',
        color: '#fff'
    },
    graphSection: {
        flex: 1,
        flexDirection: 'column',
        display: 'flex',
        position: 'relative',
        alignItems: 'center',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        //marginRight: -310,
    },

    pane: {
        position: 'absolute',
    },
}));